/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import HeaderMenuMobile from './scripts/header-menu-mobile';
import ImagesWithButton from './scripts/images-with-button';

const scripts = [PageStatus, HeaderMenuMobile, ImagesWithButton];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
